import React from 'react'

import { useState } from 'react'

import * as U from '../../utils'

import animals from '../../databases/Animals.json'

import ManyBoxes from '../../components/Spell/ManyBoxes'
import PageH2 from '../../components/PageH2/PageH2'
import PageH1 from '../../components/PageH1/PageH1'
import Page from '../../containers/Page/Page'

import TableNormal from '../../components/TableNormal/TableNormal'
import { useLocation } from 'react-router-dom'
import TwoColumns from '../../components/TwoColumns/TwoColumns'
import TwoColumnsDescriptive from '../../components/TwoColumns/TwoColumnsDescriptive'
import Column from '../../components/TwoColumns/Column'
import SmallStat from '../../components/SmallStat/SmallStat'
import Icon from '../../components/Icon'
import Separator from '../../components/Separator/Separator'
import LandingPageSeparator from '../../components/LandingPageSeparator/LandingPageSeparator'
import MonsterAbility from '../../components/MonsterAbility/MonsterAbility'
import Spell from '../../components/Spell/Spell'
import PageH3 from '../../components/PageH3/PageH3'


export function PetOrAnimalTopSide({animal}) {
    return (
        <div>
            { animal.Description != null? (
                <p>{animal.Description}</p>
            ) : (
                <p>
                    Lorem ipsum dolor sit amet.
                    Aenean blandit metus nisi, non commodo tortor volutpat ut.
                    Aenean suscipit, justo vitae faucibus viverra, lectus lacus laoreet ipsum, quis suscipit purus ex et tellus. Suspendisse congue libero sed molestie efficitur. Proin maximus sagittis nunc lacinia porttitor.
                    Maecenas fermentum lacinia mi, a elementum nibh tristique at. In eget nisl nunc.
                </p>
            ) }
            { animal.Alternatives && (
                <div style={{color: 'gray', fontStyle: 'italic' }}>
                    Alternatives: { animal.Alternatives }
                    <br/>
                    <br/>
                    <br/>
                </div>
            ) }
        </div>
    )
}
export function PetOrAnimalStats({animal}) {

    if (animal.Stats == null) {
        throw `Animal ${animal.Name} has no Stats property.`
    }

    const statValueStyle = { textAlign: 'center', width: '100%'}
    const statNameStyle  = { textAlign: 'center', width: '100%'}
    const smallStatStyle = { width: 'calc(100% / 2 - 1rem)'}

    return <div>
        <div className='flex flex-row wrap gap-1 align-left full-width width-100'>
            { animal.Health != null && <SmallStat style={smallStatStyle} contentStyle={{width: '100%'}} nameStyle={statNameStyle} valueStyle={statValueStyle} name="Health">{animal.Health}<Icon name="Health" type="small-stat"/></SmallStat> }
            { animal.Defense != null && <SmallStat style={smallStatStyle} contentStyle={{width: '100%'}} nameStyle={statNameStyle} valueStyle={statValueStyle} name="Defense">{animal.Defense}<Icon name="Defense" type="small-stat"/></SmallStat> }
            { animal.Speed != null && <SmallStat style={smallStatStyle} contentStyle={{width: '100%'}} nameStyle={statNameStyle} valueStyle={statValueStyle} name="Speed">{animal.Speed}</SmallStat> }
            { animal.Initiative != null && (<SmallStat style={smallStatStyle} contentStyle={{width: '100%'}} nameStyle={statNameStyle} valueStyle={statValueStyle} name="Initiative">{animal.Initiative}</SmallStat>) }
            { animal.Druid != null && (
                <SmallStat className="column" name="Druid Extras">{animal.Druid}</SmallStat>
            ) }
            <SmallStat style={smallStatStyle} contentStyle={{width: '100%'}} nameStyle={statNameStyle} valueStyle={statValueStyle} name="Stats">{animal.Stats.split('/').join(' / ')}</SmallStat>
        </div>       
    </div>
}
export function SpellMonsterStats({animal}) {

    const statValueStyle = { textAlign: 'center', width: '100%'}
    const statNameStyle  = { textAlign: 'center', width: '100%'}
    const smallStatStyle = { flex: 1 }

    return <div className='flex column gap-half'>
        <div className='flex row nowrap gap-half width-100'>
            { animal.Health != null && <SmallStat type="vertical" style={smallStatStyle} contentStyle={{width: '100%'}} nameStyle={statNameStyle} valueStyle={statValueStyle} name="Health">{animal.Health}<Icon name="Health" type="small-stat"/></SmallStat> }
            { animal.Defense != null && <SmallStat type="vertical" style={smallStatStyle} contentStyle={{width: '100%'}} nameStyle={statNameStyle} valueStyle={statValueStyle} name="Defense">{animal.Defense}<Icon name="Defense" type="small-stat"/></SmallStat> }
            { animal.Speed != null && <SmallStat type="vertical" style={smallStatStyle} contentStyle={{width: '100%'}} nameStyle={statNameStyle} valueStyle={statValueStyle} name="Speed">{animal.Speed}</SmallStat> }
        </div>
        { animal.Stats != null && <SmallStat type="vertical" style={smallStatStyle} contentStyle={{width: '100%'}} nameStyle={statNameStyle} valueStyle={statValueStyle} name="Stats">{animal.Stats.split('/').join(' / ')}</SmallStat> }
    </div>
}
export function PetOrAnimalAbilities({animal}) {
    if (animal.Abilities == null) {
        return <div></div>
    }
    const abilities = U.spellsFromObject(animal.Abilities)
    console.log({abilities})
    return <div className='margin-top-1'>
        { abilities.map(ability => (
            <MonsterAbility ability={ability} isPassive={ability.A == 'Passive'}/>
            // <Spell spell={ability} hasIcon={false} hasBorder={false} key={ability.Name}/>
        )) }
    </div>
}

export function PetOrAnimalBlock({animal}) {

    return (
        <div className='monster'>
            <TwoColumns type='lefty'>
                <Column>
                    <PetOrAnimalTopSide animal={animal}/>
                </Column>
                <Column>
                    {}
                </Column>
            </TwoColumns>
            <TwoColumns type='lefty'>
                <Column>
                    <PetOrAnimalStats animal={animal}/>
                </Column>
                <Column>
                    {}
                </Column>
            </TwoColumns>
            
            <TwoColumns type='lefty'>
                <Column>
                    <PetOrAnimalAbilities animal={animal}/>
                </Column>
                <Column style={{position: 'relative'}}>

                </Column>
            </TwoColumns>
        </div>
    )
}

export function PetOrAnimalSpell({animal}) {
    return <div className='monster'>
        <PageH3 className="center-text" style={{marginTop: '0px'}}>{ animal.Name }</PageH3>
        { animal.Description != null && (<p>{ animal.Description }</p>)}
        {/* <PetOrAnimalStats animal={animal}/> */}
        <SpellMonsterStats animal={animal}/>
        <PetOrAnimalAbilities animal={animal}/>
    </div>
}

export default function PetOrAnimal() {

    const location = useLocation()
    const animalName = U.getPageHashFromLocation(location)

    console.log(animalName)
    console.log({animals})

    let animal = null
    for (const category of Object.keys(animals)) {
        console.log(`Category: ${category}...${animals[category][animalName]}`)
        console.log(animals[category])
        console.log(animals[category][animalName])
        if (animals[category][animalName] != null) {
            animal = animals[category][animalName]
            break
        }
    }
    if (animal == null) {
        return (
            <Page title={`${animalName} Not Found`}></Page>
        )
    }

    return (
        <Page title={animalName}>
            <PetOrAnimalBlock animal={animal}/>
        </Page>
    )
}
